import React, { useEffect, useState } from "react";
import {
  FormTab,
  SelectInput,
  SelectArrayInput,
  required,
  Record,
  useDataProvider,
} from "react-admin";
import {
  ICompanyAppData,
  IDropDownAppData,
} from "../../../common/redux/reducers/appDataReducer";
import { useForm } from "react-final-form";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import {
  CreateFleetManagerDto,
  UpdateFleetManagerDto,
} from "../../../common/data/service-proxies";
import resourceNames from "../../../common/data/resourceNames";

interface FleetManagerSettingsFormTabProps {
  companies: ICompanyAppData[];
  groups: IDropDownAppData<number>[];
  roles: IDropDownAppData<string>[];
  record?: (UpdateFleetManagerDto | CreateFleetManagerDto) & Record;
}

export const FleetManagerSettingsFormTab = ({
  companies,
  groups,
  roles,
  ...rest
}: FleetManagerSettingsFormTabProps) => {
  const { record } = rest;
  const form = useForm();
  const dataProvider = useDataProvider();
  const [finalGroups, setFinalGroups] = useState<
    Array<IDropDownAppData<number>>
  >(groups);
  const [shouldDisableGroups, setShouldDisableGroups] = useState<boolean>(
    !groups.length
  );
  useEffect(() => {
    if (companies.length === 1 && form.getFieldState("companyIds")) {
      form.change("companyIds", [companies[0].id]);
    }
  }, [form, companies]);

  useEffect(() => {
    if (!record) {
      return;
    }

    const forbiddenGroupIds = record.groupIds?.filter((x) =>
      groups.every((g) => g.id !== x)
    );
    if (forbiddenGroupIds?.length) {
      dataProvider
        .getMany<IDropDownAppData<number> & Record>(
          resourceNames.ADMIN_GROUPS,
          { ids: forbiddenGroupIds }
        )
        .then((result) => {
          const { data } = result;
          setFinalGroups([...data, ...groups]);
          setShouldDisableGroups(true);
        })
        .catch((e) => console.error(e));
    }
  }, [groups, record, dataProvider]);

  return (
    <FormTab
      {...rest}
      label="resources.admin-fleet-managers.labels.managerSettings"
    >
      <ProtectedElement source="companyIds">
        <SelectArrayInput
          source="companyIds"
          label="resources.admin-fleet-managers.labels.companyName"
          choices={companies}
          validate={required()}
        />
      </ProtectedElement>
      <ProtectedElement source="roleName">
        <SelectInput
          source="roleName"
          label="resources.admin-fleet-managers.labels.role"
          choices={roles}
          validate={required()}
        />
      </ProtectedElement>

      <ProtectedElement source="groupIds">
        <SelectArrayInput
          label="resources.admin-fleet-managers.labels.groups"
          source="groupIds"
          choices={finalGroups}
          variant="outlined"
          disabled={shouldDisableGroups}
        />
      </ProtectedElement>
    </FormTab>
  );
};
